// Zwei Stufen fuer die Widerrufsfunktion nach § 356a BGB.
//
// Das Gesetz verlangt, dass der Verbraucher seine Erklaerung erst zusammen-
// stellt und sie dann ueber eine gesonderte Bestaetigungsfunktion absendet.
// Ein Formular mit einem einzigen Absendeknopf erfuellt das nicht.
//
// Ohne JavaScript bleibt Schritt 2 sichtbar und der Absendeknopf bedienbar:
// dann ist es einstufig, aber der Widerruf geht trotzdem raus. Lieber ein
// formal schwaecherer Weg als gar keiner.
(() => {
  const form = document.querySelector("[data-wr-form]");
  const beleg = document.querySelector("[data-beleg]");

  // --- Beleg nach dem Absenden ---------------------------------------------
  // Shopify leitet nach dem Absenden auf dieselbe Seite zurueck, die Eingaben
  // sind dann verloren. Der Inhalt der Erklaerung wurde deshalb vor dem
  // Absenden hinterlegt und wird hier wieder eingesetzt.
  if (beleg) {
    const ziel = beleg.querySelector("[data-beleg-inhalt]");
    let text = null;
    let lage = null;
    try {
      text = sessionStorage.getItem("asv-widerruf");
      lage = sessionStorage.getItem("asv-widerruf-bestaetigung");
      sessionStorage.removeItem("asv-widerruf");
      sessionStorage.removeItem("asv-widerruf-bestaetigung");
    } catch {
      /* privater Modus: dann eben ohne den Inhalt, der Zeitstempel bleibt */
    }
    if (ziel && text) {
      ziel.textContent = text;
      ziel.hidden = false;
    }
    // Der Bildschirm ist kein dauerhafter Datentraeger. Was hier steht, ist
    // deshalb nur die Auskunft darueber, ob die Bestaetigungsmail rausging.
    const versand = beleg.querySelector("[data-beleg-versand]");
    if (versand && lage) {
      versand.textContent =
        lage === "eingegangen"
          ? "Die Eingangsbestätigung ist an Ihre E-Mail-Adresse unterwegs. Sie gilt als dauerhafter Datenträger, dieser Bildschirmtext nicht."
          : "Die Eingangsbestätigung per E-Mail konnte gerade nicht verschickt werden. Ihr Widerruf ist trotzdem bei uns eingegangen; wir schicken die Bestätigung nach. Melden Sie sich bei kundenservice@asvendo.de, wenn binnen eines Werktages nichts ankommt.";
      versand.hidden = false;
    }
    beleg.querySelector("[data-drucken]")?.addEventListener("click", () => window.print());
    return;
  }

  if (!form) return;

  const schritt1 = form.querySelector('[data-wr-schritt="1"]');
  const schritt2 = form.querySelector('[data-wr-schritt="2"]');
  const vorschau = form.querySelector("[data-wr-vorschau]");
  const weiter = form.querySelector("[data-wr-weiter]");
  const zurueck = form.querySelector("[data-wr-zurueck]");
  if (!schritt1 || !schritt2 || !weiter) return;

  // Verborgen hat Schritt 2 normalerweise schon der kurze Aufruf in der Section,
  // damit er beim Aufbau der Seite nicht aufblitzt. Hier steht es ein zweites
  // Mal fuer den Fall, dass jener Aufruf nicht durchkam (etwa weil eine
  // Content-Security-Policy Inline-Skripte sperrt). Zweimal verbergen schadet
  // nicht, einmal zu wenig schon.
  schritt2.hidden = true;

  const wert = (name) => form.querySelector(`[name="contact[${name}]"]`)?.value.trim() || "";

  // Der Text, den der Verbraucher bestaetigt, und zugleich der Inhalt der
  // Erklaerung, der spaeter auf dem Beleg steht. Beides muss dasselbe sein.
  function erklaerung() {
    const zeilen = [
      "Hiermit widerrufe ich den von mir abgeschlossenen Vertrag über den Kauf der folgenden Waren:",
      "",
      `Bestellnummer: ${wert("Bestellnummer")}`,
      `Umfang: ${wert("Umfang") || "Die gesamte Bestellung"}`,
    ];
    const artikel = wert("Betroffene Artikel");
    if (artikel) zeilen.push(`Betroffene Artikel: ${artikel.replace(/\s*\n\s*/g, "; ")}`);
    const bestellt = wert("Bestellt am");
    if (bestellt) zeilen.push(`Bestellt am: ${bestellt}`);
    const erhalten = wert("Erhalten am");
    if (erhalten) zeilen.push(`Erhalten am: ${erhalten}`);
    const grund = wert("Grund, freiwillig");
    if (grund) zeilen.push(`Grund (freiwillig): ${grund}`);
    zeilen.push("", `Name: ${wert("Name")}`, `E-Mail: ${wert("email")}`);
    return zeilen.join("\n");
  }

  weiter.addEventListener("click", () => {
    // Die eingebaute Pflichtfeldpruefung des Browsers nutzen, statt sie
    // nachzubauen: sie meldet in der Sprache des Nutzers und setzt den Fokus.
    const pflicht = [...schritt1.querySelectorAll("[required]")];
    for (const feld of pflicht) {
      if (!feld.checkValidity()) {
        feld.reportValidity();
        return;
      }
    }
    vorschau.textContent = erklaerung();
    schritt1.hidden = true;
    schritt2.hidden = false;
    // Fokus mitnehmen, sonst steht ein Tastaturnutzer nach dem Wechsel im Nichts.
    schritt2.querySelector("h2")?.setAttribute("tabindex", "-1");
    schritt2.querySelector("h2")?.focus();
    schritt2.scrollIntoView({ block: "start", behavior: "smooth" });
  });

  zurueck?.addEventListener("click", () => {
    schritt2.hidden = true;
    schritt1.hidden = false;
    schritt1.querySelector("h2")?.setAttribute("tabindex", "-1");
    schritt1.querySelector("h2")?.focus();
  });

  // Ab hier gilt das Formular als betreut: der Absendeknopf ist erreichbar.
  form.setAttribute("data-wr-bereit", "");

  // Wer bestaetigt hat, hat Schritt 2 gesehen. Ohne diese Merkung genuegt die
  // Eingabetaste in einem Pflichtfeld, um direkt aus Schritt 1 abzusenden —
  // dann waere die Zweistufigkeit nur noch optisch vorhanden.
  let bestaetigt = false;
  form.querySelector("[data-wr-bestaetigen]")?.addEventListener("click", () => {
    bestaetigt = true;
  });

  // --- Eingangsbestaetigung auf dauerhaftem Datentraeger --------------------
  // § 356 Abs. 1 Satz 2 BGB verlangt zusaetzlich zum Formular eine
  // unverzuegliche Bestaetigung des Zugangs an den Verbraucher. Shopifys
  // Kontaktformular schreibt nur an den Haendler, deshalb geht die Erklaerung
  // zusaetzlich an einen eigenen Endpunkt, der die Mail verschickt.
  //
  // Ist keine Adresse eingestellt, bleibt alles wie zuvor. Die Section haelt
  // die Widerrufsbelehrung dann weiterhin zurueck.
  const endpunkt = (form.dataset.wrEndpunkt || "").trim();

  async function bestaetigungAnfordern() {
    const abbruch = new AbortController();
    // Sechs Sekunden. Laenger warten hiesse, den Verbraucher vor einem
    // scheinbar haengenden Knopf sitzen zu lassen; kuerzer reisst bei
    // langsamer Mobilfunkverbindung zu frueh ab.
    const uhr = setTimeout(() => abbruch.abort(), 6000);
    try {
      const antwort = await fetch(endpunkt, {
        method: "POST",
        headers: { "content-type": "application/json", accept: "application/json" },
        signal: abbruch.signal,
        body: JSON.stringify({
          name: wert("Name"),
          bestellnummer: wert("Bestellnummer"),
          email: wert("email"),
          umfang: wert("Umfang"),
          artikel: wert("Betroffene Artikel"),
          bestelldatum: wert("Bestellt am"),
          erhalt: wert("Erhalten am"),
          grund: wert("Grund, freiwillig"),
          // Der Haendler bekommt den Vorgang bereits ueber das
          // Kontaktformular. Eine zweite Kopie waere nur Rauschen.
          nur_bestaetigung: "1",
        }),
      });
      const daten = await antwort.json().catch(() => ({}));
      return daten.lage === "eingegangen" ? "eingegangen" : "offen";
    } catch {
      return "offen";
    } finally {
      clearTimeout(uhr);
    }
  }

  let laeuft = false;
  form.addEventListener("submit", (e) => {
    if (!bestaetigt) {
      e.preventDefault();
      weiter.click();
      return;
    }
    try {
      sessionStorage.setItem("asv-widerruf", erklaerung());
    } catch {
      /* ohne Sitzungsspeicher fehlt spaeter nur der Inhalt auf dem Beleg */
    }
    if (!endpunkt || laeuft) return;

    // Das Absenden anhalten, bis die Bestaetigung draussen ist. Ein
    // keepalive-Aufruf waere bequemer, verschluckt aber die Antwort — und
    // ohne Antwort weiss der Beleg nicht, ob die Mail wirklich rausging.
    e.preventDefault();
    laeuft = true;
    const knopf = form.querySelector("[data-wr-bestaetigen]");
    if (knopf) {
      knopf.disabled = true;
      knopf.textContent = "Wird gesendet …";
    }
    bestaetigungAnfordern().then((lage) => {
      try {
        sessionStorage.setItem("asv-widerruf-bestaetigung", lage);
      } catch {
        /* ohne Sitzungsspeicher fehlt nur die Auskunft auf dem Beleg */
      }
      form.submit();
    });
  });
})();
